import { ResourceHelperService } from "../resource-helper.service";

/**
 * A dataservice that performs operations on Secure Usage Token entries against the backend Secure Usage Token Service
 */
export class SecureUsageTokenService {
  public secureUsageTokenResource: InterACT.Interfaces.IResource<InterACT.Interfaces.SecureUsageTokens.SecureUsageTokensResponse>;

  constructor($resource, private resourceHelperService: ResourceHelperService) {
    this.secureUsageTokenResource = $resource('api/secure-usage-tokens/:secureUsageTokenId', undefined);
  }

  /**
   * Retrieves a list of Secure Usage Tokens
   *
   * @param page The number of the page of data to be retrieved
   * @param perPageCount The number of items per page to be retrieved
   * @param searchText The query to search for Charge Account
   *
   * @returns A promise of a SecureUsageTokensResponse
   */
  public getSecureUsageTokens(page: number, perPageCount: number, searchText: string) {
    const options = this.resourceHelperService.buildRequestOptions(page, perPageCount, searchText);
    return this.secureUsageTokenResource.get(options).$promise.then((response) => {
      return response.secureUsageTokens;
    });
  }
}